<div class="footer-container">
  <footer id="footer" class="footer">
    <div class="container">
      <div class="mx-auto lpl-logo my-3">
        <img src="assets/images/lpl-logo.svg">
      </div>
      <div class="text-center mb-2">
        <a tabindex="0" (click)="openModal('termsOfUse', 'About This Site', 'Close');"  (keydown.enter)="openModal('termsOfUse', 'About This Site', 'Close');">
          {{"copy.label.FOOTER.termsofuse" | copy | async}}
        </a>
        <a href="https://www.lpl.com/disclosures/privacy-security.html" target="_blank">
          {{"copy.label.FOOTER.privacy" | copy | async}}
        </a>
   
        <!-- OneTrust Cookies Settings button start -->
        <a class="ot-sdk-show-settings" id="cookieSettings" style="display:none"></a>
        <a tabindex="0"  tabindex="0" (click)="cookieEnglish()" (keyup.enter)="cookieEnglish()">Cookie Settings</a>
        <!-- <a tabindex="0" tabindex="0" (click)="cookieSpanish()" (keyup.enter)="cookieSpanish()">Configuración de Cookies</a> -->
        <!-- OneTrust Cookies Settings button end -->
      </div>
      <div class="text-center mb-2">
        <a href="https://maritz.com" target="_blank"
          >Powered by <span class="sr-only">Maritz</span> <svg class="svg-fill mtlogo" aria-hidden="true">
            <use xlink:href="assets/images/maritz-logo.svg#maritz"></use>
          </svg></a>
      </div>
    </div>
  </footer>
</div>
